// extracted by mini-css-extract-plugin
module.exports = {"root":"TabTitle_root__1ZMwN","title":"TabTitle_title__2mJqH","selected":"TabTitle_selected__3Oo0i"};